<template>
  <base-container class="cascade-picker-page">
    <view class="btn-item">
      <basic-picker />
    </view>
    <view class="btn-item">
      <slot-picker />
    </view>
    <view class="btn-item">
      <async-picker />
    </view>
  </base-container>
</template>

<script>
import { createPage } from '@mpxjs/core'

createPage({})
</script>

<style lang="stylus">
.btn-item
  margin-bottom 15px
</style>

<script type="application/json">
  {
    "usingComponents": {
      "base-container": "../../components/base-container/index",
      "cube-divider": "@mpxjs/mpx-cube-ui/src/components/divider/index",
      "basic-picker": "./basic-picker",
      "slot-picker": "./slot-picker",
      "async-picker": "./async-picker"
    }
  }
</script>
